import React from 'react';
import { AVATAR_COLORS, getInitials } from '../lib/family';

export default function Avatar({ name, color = 'pink', photo, size = 48, ring = false, className = '' }) {
    const palette = AVATAR_COLORS[color] || AVATAR_COLORS.pink;
    const fontSize = Math.floor(size * 0.36);
    const style = {
        width: size,
        height: size,
        backgroundColor: photo ? '#fff' : palette.bg,
        color: palette.text,
        fontSize,
        border: ring ? `3px solid ${palette.border}` : 'none',
    };

    if (photo) {
        return (
            <div className={`relative rounded-full overflow-hidden flex-shrink-0 ${className}`} style={{ width: size, height: size, border: `3px solid ${palette.border}` }}>
                <img src={photo} alt={name || ''} className="w-full h-full object-cover" />
            </div>
        );
    }

    return (
        <div
            className={`rounded-full flex items-center justify-center font-bold flex-shrink-0 ${className}`}
            style={style}
            aria-label={name}
        >
            {getInitials(name)}
        </div>
    );
}
